// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + {"538":"recorder","983":"profiler"}[chunkId] + "." + {"538":"9f62ca03b0fc1ed1","983":"4d1c1da352e88f4e"}[chunkId] + ".js";
};